
<nz-select nzShowSearch nzAllowClear nzServerSearch [nzLoading]="loading"  [compareWith]="compareFn" [nzDisabled]="searchProperties.disabled"  [nzPlaceHolder]="searchProperties.placeholder|translateTA"  [nzSize]="searchProperties.size == null? 'default': searchProperties.size" (nzOnSearch)="onSearch($event)"  (nzOnClear)="onClear($event)" (ngModelChange)="handlingChange($event)" [(ngModel)]="value">
    @if (!loading) {
        @for (o of optionList; track o.key) {
        <nz-option [nzValue]="searchProperties.showKey? {key: o.key, value: o.value} : o.value" [nzLabel]="searchProperties.showKey? (o.key + ' - '+ o.value): o.value"></nz-option>
        }
    } @else {
        <nz-option nzDisabled nzCustomContent>
        <nz-icon nzType="loading" class="loading-icon" />
            {{'loading.data'|translateTA}}
        </nz-option>
    }
</nz-select>
        